module.exports = __webpack_public_path__ + "static/media/truck_red_temp_yellow.f60ee9d1.png";